import { IndexedDB } from './IndexedDB'
import { RepositoryBase } from './RepositoryBase'

export class IndexedDBState extends RepositoryBase {
  static dbName = 'analytics'
  static dbVersion = 1
  static storeName = 'usersSessions'
  static DB = null

  // connect to IndexedDB database
  async dbConnect() {
    IndexedDBState.DB =
    IndexedDBState.DB ||
      (await new IndexedDB(IndexedDBState.dbName, IndexedDBState.dbVersion, (db, oldVersion) => {
        // upgrade database
        switch (oldVersion) {
          case 0: {
            db.createObjectStore(IndexedDBState.storeName, { keyPath: 'id', autoIncrement: true })
          }
        }
      }))

    return IndexedDBState.DB
  }

  async getEvents() {
    const db = await this.dbConnect()
    return await db.getEvents(IndexedDBState.storeName)
  }

  async saveEvent(data) {
    const db = await this.dbConnect()
    await db.saveEvent(IndexedDBState.storeName, data) 
  }

  async removeEvents() {
    const db = await this.dbConnect()
    return await db.removeEvents(IndexedDBState.storeName)
  }

}

export default new IndexedDBState
